<script lang="ts">
	import EnergyDistributionZendureV2 from 'src/components/Integrations/Zendure/EnergyDistributionZendureV2.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content">
		<EnergyDistributionZendureV2 {device} />
	</div>
</DeviceViewStateWrapper>
